import React from 'react';
import { useTranslation } from 'react-i18next';
import BellIcon from '../../resources/assets/icons/BellIcon';
import { RouteEnum } from '../../routes/routes';
import { Button } from 'antd';

export default function ErrorView() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Error' });

  const navigateHome = () => (window.location.href = RouteEnum.Home);

  return (
    <div className="flex flex-col justify-center h-screen">
      <div className="flex flex-col w-4/5 space-y-lg mx-auto">
        <BellIcon className="mx-auto" />
        <h5 className="text-center">{t('header')}</h5>
        <p className="text-center">{t('text')}</p>
        <div className="flex w-2/3 mx-auto">
          <Button type="primary" size="large" className="mx-auto" onClick={navigateHome}>
            {t('button')}
          </Button>
        </div>
      </div>
    </div>
  );
}
